
import { DISPATCH_CLEAR, DISPATCH_SAVE } from '@/store/types'

export const dispatch = {
  [DISPATCH_SAVE](state, data) {
    state.dispatch.key = data.key
    state.dispatch.data = data.data
  },
  [DISPATCH_CLEAR](state) {
    state.dispatch.key = ''
    state.dispatch.data = {}
  }
}
